import ProfessorInfo from "../../components/Professor/ProfessorInfo";
import Greetings from "../../components/Professor/Greetings";

export default function Professor() {
  return (
    <>
        <ProfessorInfo />
        <Greetings />
    </>
  );
}
